<div class="w-full p-8 bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <!-- HEADER -->
      <div class="flex justify-between items-center">
        <div>
          <h1 class="text-4xl font-semibold text-gray-900">
            Gestion des appels
          </h1>
          <p class="text-slate-600 mt-2">
            {{ totalElementsAll }} appel(s) trouvé(s)
          </p>
        </div>

        <!-- DROPDOWN -->
        <div class="relative" *ngIf="!isBeninGestionnaire">
          <button (click)="toggleDropdown()"
            class="flex items-center gap-2 px-4 py-2 border rounded-lg shadow bg-white hover:bg-gray-100">
            <img src="assets/icons/plus.png" width="20" />
            <span>Créer un appel</span>
          </button>

          <div *ngIf="isDropdownOpen" class="absolute right-0 mt-2 w-56 bg-white border rounded-lg shadow">
            <a [routerLink]="['../candidature']" class="block px-4 py-2 hover:bg-gray-100">
              Appel de parcours
            </a>
            <a [routerLink]="['/dashboard/appels/candidatureHorsParcours']" class="block px-4 py-2 hover:bg-gray-100">
              Appel hors parcours
            </a>
            <a [routerLink]="['/dashboard/mentorat/candidatureMentors']" class="block px-4 py-2 hover:bg-gray-100">
              Appel mentorat
            </a>
            <a *ngIf="isAdmin" [routerLink]="[
                '/dashboard/application-simplify/candidaturewebinaire',
              ]" class="block px-4 py-2 hover:bg-gray-100">
              Appel webinaire
            </a>
          </div>
        </div>
      </div>

      <!-- FILTERS -->
      <div class="mt-6 flex gap-3 flex-wrap" *ngIf="!isBeninGestionnaire">
        <button (click)="filterApplications('all')" [ngClass]="
            filterType === 'all' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          " class="px-4 py-2 rounded">
          Tous
        </button>
        <button (click)="filterApplications('parcours')" [ngClass]="
            filterType === 'parcours' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          " class="px-4 py-2 rounded">
          Parcours
        </button>
        <button (click)="filterApplications('horsParcours')" [ngClass]="
            filterType === 'horsParcours'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200'
          " class="px-4 py-2 rounded">
          Hors parcours
        </button>
        <button *ngIf="isAdmin" (click)="filterApplications('webinaire')" [ngClass]="
            filterType === 'webinaire'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200'
          " class="px-4 py-2 rounded">
          Webinaire
        </button>
        <button (click)="filterApplications('mentorat')" [ngClass]="
            filterType === 'mentorat' ? 'bg-blue-600 text-white' : 'bg-gray-200'
          " class="px-4 py-2 rounded">
          Mentorat
        </button>
      </div>

      <!-- LOADING -->
      <div *ngIf="isLoading" class="text-center p-6">Chargement...</div>

      <!-- TABLE -->
      <div *ngIf="!isLoading" class="mt-6 overflow-auto">
        <table class="w-full border rounded-lg">
          <thead class="bg-gray-100">
            <tr>
              <th class="p-3 text-left">Statut</th>
              <th class="p-3 text-left">Nom</th>
              <th class="p-3 text-left">Informations</th>
              <th class="p-3 text-left" *ngIf="!isBeninGestionnaire">Type</th>
              <th *ngIf="isAdmin && filterType !== 'all'" class="p-3 text-left">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let app of applicationToDisplay" class="border-t">
              <td class="p-3">
                <span [style.backgroundColor]="
                    app?.applicationStatus === 'Terminé'
                      ? '#f04438'
                      : app?.applicationStatus === 'En cours'
                        ? '#28b45b'
                        : '#ffbf00'
                  " class="text-white px-3 py-1 rounded-full text-sm whitespace-nowrap">
                  {{ app?.applicationStatus }}
                </span>
              </td>

              <td class="p-3">
                {{ app?.applicationName || "Nom non disponible" }}
              </td>

              <td class="p-3">
                {{ app?.applicationInformations || "Pas d info" }}
              </td>

              <td class="p-3" *ngIf="!isBeninGestionnaire">
                {{
                app.applicationType === "parcours"
                ? "Parcours"
                : app.applicationType === "horsParcours"
                ? "Hors parcours"
                : app.applicationType === "mentorat"
                ? "Mentorat"
                : app.applicationType === "webinaire"
                ? "Webinaire"
                : "Type inconnu"
                }}
              </td>
              <td *ngIf="isAdmin && filterType !== 'all'" class="p-3">
                <ng-container [ngSwitch]="app.applicationType">

                  <!-- PARCOURS -->
                  <div *ngSwitchCase="'parcours'" class="flex items-center gap-2">
                    <button (click)="openToggleConfirm(app)" [title]="
                        app.applicationStatus === 'Terminé'
                          ? 'Appel clôturé automatiquement'
                          : app.applicationStatus === 'À venir'
                            ? 'Appel pas encore ouvert, action impossible'
                            : app.applicationLaunch ? 'Clôturer l\'appel' : 'Ouvrir l\'appel'
                      " [disabled]="app.applicationStatus === 'Terminé'" [ngClass]="
                      app.applicationStatus === 'Terminé'
                          ? 'opacity-30 cursor-not-allowed'
                          : 'hover:bg-gray-100 focus:ring-2 focus:ring-gray-100'
                      " class="focus:outline-none p-1 w-fit text-center flex items-center gap-1">
                      <svg *ngIf="app.applicationLaunch" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-green-600">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M13.5 10.5V6.75a4.5 4.5 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                      <svg *ngIf="!app.applicationLaunch" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-red-500">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                      <!-- <span class="text-xs">{{ app.applicationLaunch ? 'En cours' : 'Clôturé' }}</span> -->
                    </button>

                    <button (click)="editApplicationp(app)" title="Modifier l'appel"
                      class="hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 focus:outline-none p-1 w-fit text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                        stroke="currentColor" class="h-6 text-blue-600">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931zm0 0L19.5 7.125" />
                      </svg>
                    </button>
                  </div>

                  <!-- MENTORAT -->
                  <div *ngSwitchCase="'mentorat'" class="flex items-center gap-2">
                    <button (click)="openToggleConfirm(app)" [title]="
                        app.applicationStatus === 'Terminé'
                          ? 'Appel clôturé automatiquement'
                          : app.applicationStatus === 'À venir'
                            ? 'Appel pas encore ouvert, action impossible'
                            : app.applicationLaunch ? 'Clôturer l\'appel' : 'Remettre en cours'
                      " [disabled]="app.applicationStatus === 'Terminé'" [ngClass]="
                      app.applicationStatus === 'Terminé'
                          ? 'opacity-30 cursor-not-allowed'
                          : 'hover:bg-gray-100 focus:ring-2 focus:ring-gray-100'
                      " class="focus:outline-none p-1 w-fit text-center flex items-center gap-1">
                      <svg *ngIf="app.applicationLaunch" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-green-600">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M13.5 10.5V6.75a4.5 4.5 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                      <svg *ngIf="!app.applicationLaunch" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-red-500">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                      <!-- <span class="text-xs">{{ app.applicationLaunch ? 'En cours' : 'Clôturé' }}</span> -->
                    </button>

                    <button (click)="editApplicationp(app)" title="Modifier l'appel"
                      class="hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 focus:outline-none p-1 w-fit text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                        stroke="currentColor" class="h-6 text-blue-600">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931zm0 0L19.5 7.125" />
                      </svg>
                    </button>
                  </div>
                  <div *ngIf="app.applicationType === 'horsParcours' || app.applicationType === 'webinaire'"
                    class="flex items-center gap-2">
                    <button (click)="openToggleModal(app)" [title]="
    app.applicationStatus === 'Terminé'
      ? 'Appel terminé, action impossible'
        : app.applicationLaunch ? 'Clôturer l\'appel' : 'Ouvrir l\'appel'
  " [disabled]="app.applicationStatus === 'Terminé'" [ngClass]="
    app.applicationStatus === 'Terminé'
      ? 'opacity-30 cursor-not-allowed'
      : 'hover:bg-gray-100 focus:ring-2 focus:ring-gray-100'
  " class="focus:outline-none p-1 w-fit text-center">
                      <!-- applicationLaunch = true (lancé) → cadenas OUVERT vert -->
                      <svg *ngIf="app.applicationLaunch" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-green-600">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M13.5 10.5V6.75a4.5 4.5 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                      <!-- applicationLaunch = false (clôturé) → cadenas FERMÉ rouge -->
                      <svg *ngIf="!app.applicationLaunch" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-red-500">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                    </button>

                    <button (click)="editApplicationp(app)" title="Modifier l'appel"
                      class="focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 p-1 w-fit text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                        stroke="currentColor" class="h-6 text-blue-600">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931zm0 0L19.5 7.125" />
                      </svg>
                    </button>

                    <button *ngIf="app.applicationType === 'webinaire' && app.applicationLink"
                      (click)="copyApplicationLink(app)"
                      [title]="copiedAppId === app.id ? 'Lien copié !' : 'Copier le lien : ' + app.applicationLink"
                      class="focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 p-1 w-fit text-center flex items-center gap-1">

                      <!-- Icône copier -->
                      <svg *ngIf="copiedAppId !== app.id" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="h-6 text-gray-700">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                      </svg>

                      <!-- Icône validé -->
                      <svg *ngIf="copiedAppId === app.id" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 text-green-600">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                      <span *ngIf="copiedAppId === app.id" class="text-xs text-green-600">Copié</span>
                    </button>
                    <button *ngIf="app.applicationType === 'horsParcours' && app.applicationLink"
                      (click)="copyLink(app)" [title]="app.copied ? 'Lien copié !' : 'Copier le lien'"
                      class="focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 p-1 w-fit text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1"
                        stroke="currentColor" class="h-6" [ngClass]="app.copied ? 'text-green-600' : 'text-gray-600'">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                      </svg>
                    </button>
                  </div>


                  <!-- <span *ngSwitchDefault class="text-gray-400">—</span> -->
                </ng-container>
              </td>
            </tr>

            <tr *ngIf="applicationToDisplay.length === 0">
              <td [attr.colspan]="(isAdmin && filterType !== 'all') ? 5 : 4" class="text-center p-4 text-gray-500">
                Aucune donnée
              </td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATOR -->
        <mat-paginator [length]="currentTotalElements" [pageSize]="currentPageSize" [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="currentPageIndex" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
        <!-- Modale de confirmation Clôturer / En cours -->
        <div *ngIf="showToggleConfirmModal"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6">
            <div class="flex flex-col items-center gap-3 text-center">
              <div class="bg-yellow-100 rounded-full p-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-yellow-600" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
              </div>
              <h2 class="text-2xl font-semibold text-gray-900">
                Confirmer l'action
              </h2>
            </div>

            <!-- Message -->
            <div class="flex justify-center items-center">
              <p class="text-lg text-center leading-relaxed text-gray-700 dark:text-gray-400">
                <!-- Cas clôture -->
                <ng-container *ngIf="applicationToToggle?.applicationLaunch">
                  Vous êtes sur le point de
                  <strong>clôturer</strong> l'appel
                  <strong>{{ applicationToToggle?.applicationName }}</strong>.<br />
                  Plus personne ne pourra soumettre de candidature après cette
                  action.
                </ng-container>
                <!-- Cas réouverture -->
                <ng-container *ngIf="!applicationToToggle?.applicationLaunch">
                  Vous êtes sur le point de
                  <strong>remettre en cours</strong> l'appel
                  <strong>{{ applicationToToggle?.applicationName }}</strong>.<br />
                  Les candidats pourront à nouveau soumettre leur candidature.
                </ng-container>
              </p>
            </div>

            <!-- Boutons -->
            <div class="flex justify-end gap-3">
              <button (click)="cancelToggle()"
                class="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 cst-transition focus:outline-none">
                Annuler
              </button>
              <button (click)="confirmToggle()"
                class="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-700 text-white font-bold cst-transition focus:outline-none focus:shadow-outline">
                Confirmer
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="showToggleModal" tabindex="-1" style="z-index: 99999" aria-hidden="true"
          class="bg-opacity-70 bg-gray-100 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
          <div class="relative w-auto my-6 mx-auto max-w-6xl mt-6">
            <div class="relative p-4 w-full max-w-2xl max-h-full">
              <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
                <div class="p-4 md:p-5 space-y-4 items-center justify-center">
                  <!-- Icône -->
                  <div class="flex justify-center items-center">
                    <div class="mx-auto flex h-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0"
                      [ngClass]="appToToggle?.applicationLaunch ? 'bg-red-100' : 'bg-green-100'" style="width: 11%">
                      <svg *ngIf="appToToggle?.applicationLaunch" class="h-10 w-10 text-red-600" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                      <svg *ngIf="!appToToggle?.applicationLaunch" class="h-10 w-10 text-green-600" fill="none"
                        viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                          d="M13.5 10.5V6.75a4.5 4.5 0 0 1 4.5-4.5 4.5 4.5 0 0 1 4.5 4.5v3.75M3.75 21.75h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H3.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                      </svg>
                    </div>
                  </div>

                  <!-- Message -->
                  <div class="flex justify-center items-center">
                    <p class="text-lg text-center leading-relaxed text-gray-700 dark:text-gray-400">
                      <ng-container *ngIf="appToToggle?.applicationLaunch">
                        Vous êtes sur le point de
                        <strong>Clôturer</strong> l'appel
                        <strong>{{ appToToggle?.applicationName }}</strong>.<br />
                        Plus personne ne pourra postuler après cette action.
                      </ng-container>
                      <ng-container *ngIf="!appToToggle?.applicationLaunch">
                        Vous êtes sur le point d'
                        <strong>Ouvrir</strong> l'appel
                        <strong>{{ appToToggle?.applicationName }}</strong>.<br />
                        Les candidats pourront à nouveau postuler.
                      </ng-container>
                    </p>
                  </div>

                  <!-- Boutons -->
                  <div class="flex justify-center items-center">
                    <button (click)="confirmToggleLaunch()" type="button"
                      [ngClass]="appToToggle?.applicationLaunch ? 'bg-red-600 hover:bg-red-500' : 'bg-green-600 hover:bg-green-500'"
                      class="w-full justify-center ml-3 rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto">
                      {{ appToToggle?.applicationLaunch ? "Clôturer" : "Ouvrir" }}
                    </button>
                    <button (click)="closeToggleModal()" type="button"
                      class="mt-3 w-full justify-center ml-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
